<template>
  <div class="sfdr-tooltip">
    <div
      class="tooltip-arrow-header"
      :class="{
        'arrow-left': orientation.x === 'right',
        'arrow-right': orientation.x === 'left',
        'arrow-top': orientation.y === 'bottom',
        'arrow-bottom': orientation.y === 'top',
      }"
    />
    <div class="tooltip-header">
      {{ title }}
    </div>
    <div class="tooltip-content">
      <div
        v-for="item in config"
        :key="item.title"
        class="tooltip-item"
      >
        <div class="tooltip-title">
          {{ item.title }}
        </div>
        <component
          :is="item.component"
          v-if="item.component"
          v-bind="item.props"
          class="tooltip-value"
        />
        <div
          v-else
          :style="{ color: item.colorValue }"
          class="tooltip-value"
        >
          {{ item.value }}
        </div>
      </div>
    </div>
    <div class="tooltip-arrow" />
  </div>
</template>

<script>
export default {
  name: 'GenericTooltip',
  props: {
    title: {
      type: String,
      default: ''
    },
    config: {
      type: Array,
      default: () => ([])
    },
    orientation: {
      type: Object,
      default: () => ({ x: 'right', y: 'bottom' })
    }
  }
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.sfdr-tooltip {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 0;
  width: fit-content;
  position: relative;
  font-family: 'Arial', sans-serif;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  margin-left: 10px;
}

.tooltip-header {
  font-size: 18px;
  color: white;
  background-color: map_get($palette-primary, main);
  padding: 12px 10px;
  border-radius: 4px 4px 0 0;
  text-align: center;
}

.tooltip-arrow-header {
  position: absolute;
  margin-top: -5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 10px 0;
  border-color: transparent map_get($palette-primary, main) transparent transparent;
}

.arrow-left {
  left: -10px;
}

.arrow-right {
  left: calc(100%);
  transform: rotate(180deg);
}

.arrow-top {
  top: 10%;
}

.arrow-bottom {
  top: 91%;
}

.tooltip-content .tooltip-item {
  padding: 15px;
  border-bottom: 1px solid #ccc;
}

.tooltip-content .tooltip-item:last-child {
  border-bottom: none;
}

.tooltip-title {
  font-size: 1rem;
  color: #999;
  text-transform: uppercase;
  color: $color-daddy;
  margin-bottom: 4px;
}

.tooltip-value {
  font-size: 16px;
  font-weight: bold;
}

.tooltip-arrow {
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 5px 5px;
  border-color: transparent transparent #f9f9f9 transparent;
}
</style>
